/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svr_TitleInputs */

const en_svr_title = /** @type {(inputs: Svr_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generate Site Visit Report (SVR)`)
};

const ja_svr_title = /** @type {(inputs: Svr_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`訪問報告書を作成（SVR）`)
};

const fr_svr_title = /** @type {(inputs: Svr_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Générer un rapport de visite (SVR)`)
};

const de_svr_title = /** @type {(inputs: Svr_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Besuchsbericht erstellen (SVR)`)
};

/**
* | output |
* | --- |
* | "Generate Site Visit Report (SVR)" |
*
* @param {Svr_TitleInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const svr_title = /** @type {((inputs?: Svr_TitleInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svr_TitleInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_svr_title(inputs)
	if (locale === "ja") return ja_svr_title(inputs)
	if (locale === "fr") return fr_svr_title(inputs)
	return de_svr_title(inputs)
});